var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_30945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.793 33.3178C17.7159 28.2408 17.7159 20.0101 22.793 14.9331M27.042 12.0983C31.7471 10.1665 37.3565 11.1119 41.1777 14.9331C46.2548 20.0101 46.2548 28.2408 41.1777 33.3178C37.3565 37.139 31.7471 38.0845 27.042 36.1526",
    stroke: "#523FF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.207 33.3178C20.1302 38.3947 11.8991 38.3947 6.82226 33.3178C1.74544 28.241 1.74544 20.0099 6.82226 14.9331C11.8991 9.85625 20.1302 9.85625 25.207 14.9331C30.2839 20.0099 30.2839 28.241 25.207 33.3178Z",
    stroke: "#523FF6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0318 30.0787L21.0367 30.0369M28.4887 24.0941L19.4961 24.0314M26.9481 18.0885L20.9531 18.0467",
    stroke: "#523FF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_30945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "matrix(-1 0 0 1 48.5 0.125458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.b5d2709ceec642e6b4c9d962294f148f.svg";
export { ForwardRef as ReactComponent };